import { Chip } from "@mui/material";
import styled from "styled-components";
import type { CaseCopyStatus } from "src/types";
import { caseCopyStatusBackgroundColor, caseCopyStatusTextColor } from "src/utils/case.utils";

export const CaseCopyStatusChip = styled(Chip).attrs((props: { status: CaseCopyStatus }) => ({
  status: props.status,
}))`
  background-color: ${({ status }) => caseCopyStatusBackgroundColor(status)};
  color: ${({ status }) => caseCopyStatusTextColor(status)};
`;
